import ObjectsViewProvider from "./ObjectsView.provider"
import ObjectsViewPhase from "./ObjectsViewControls/ObjectsViewPhase/ObjectsViewPhase"
import ObjectsViewSearchInput from "./ObjectsViewControls/ObjectsViewSearchInput/ObjectsViewSearchInput"
import ObjectsViewTab from "./ObjectsViewControls/ObjectsViewTab/ObjectsViewTab"
import ObjectsViewTabs from "./ObjectsViewControls/ObjectsViewTabs/ObjectsViewTabs"

export default {
    Provider: ObjectsViewProvider,
    Phase: ObjectsViewPhase,
    Tabs: ObjectsViewTabs,
    Tab: ObjectsViewTab,
    SearchInput: ObjectsViewSearchInput,
}
